import React from 'react'
import { Card, CardContent, Box } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import { useStyles } from './ExpandedSkeletonNewsCard.styles'

const ExpandedSkeletonNewsCard = () => {
  const classes = useStyles()

  return (
    <Card className={classes.card}>
      <Skeleton
        variant="rect"
        className={classes.img}
        animation="wave"
        height={250}
      />
      <CardContent className={classes.cardContent}>
        <Box className={classes.titleWrapper}>
          <Skeleton variant="text" width="100%" height={35} animation="wave" />
          <Skeleton variant="text" width="80%" height={35} animation="wave" />
          {[...Array(2)].map((_, i) => (
            <Skeleton
              key={i}
              variant="text"
              width="100%"
              height={20}
              animation="wave"
              className={classes.displayNone}
            />
          ))}
        </Box>
        <Box className={classes.actions}>
          <Skeleton
            className={classes.actionsSkeleton}
            variant="text"
            height={20}
            animation="wave"
          />
        </Box>
      </CardContent>
    </Card>
  )
}

export default ExpandedSkeletonNewsCard
